import { render, staticRenderFns } from "./AppUserAttendenceRecords.vue?vue&type=template&id=650621d8&scoped=true"
import script from "./AppUserAttendenceRecords.vue?vue&type=script&lang=js"
export * from "./AppUserAttendenceRecords.vue?vue&type=script&lang=js"
import style0 from "./AppUserAttendenceRecords.vue?vue&type=style&index=0&id=650621d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650621d8",
  null
  
)

export default component.exports